import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';
import Select, { components } from 'react-select';
import {
    ReportParameterContainer,
    DoubleListContainer,
    DoubleListSubContainer,
    ListContainer,
    ListContainerLeft,
    ListContainerRight,
    ContainerMiddle,
    Ul,
    Subtitle,
    Line,
    SearchButtonsContainer,
} from './styles';
import FilterIcon from '../../assets/filter_icon.png';
import ModalCancel from '../Modal/Cancel';
import ModalWarn from '../Modal/Warn/index';
import { statusOrgaoEnum } from '../../constants'
import DropUpIcon from '../../assets/drop_up_icon.png';
import DropDownIcon from '../../assets/drop_down_icon.png';

export default function ReportInputSelectElements(props) {
    const [modalCancel, setModalCancel] = useState(false);
    const [enableBtnReportGenerate, setEnableBtnReportGenerate] = useState(false);
    const { handleSubmit } = useForm();
    const [selectedOptionStatusOrgao, setSelectedOptionStatusOrgao] = useState();
    const [presencialAttendance, setPresencialAttendance] = useState(false);
    const [agencyName, setAgencyName] = useState();

    let statusOrgaoOptions =
    Object.entries(statusOrgaoEnum.getLabels)
        .filter(([key, value]) => key !== "getLabelByValue") // remove o método 'getLabelByValue'
        .map(([key, value]) => ({
            value: key,
            label: value
        }));
    statusOrgaoOptions.unshift({value: "TODOS", label: "Todos"})

    function resetFilters() {
        document.getElementById("left-filter").value = "";
        setAgencyName(undefined);
        setSelectedOptionStatusOrgao(statusOrgaoOptions[0])
        setPresencialAttendance(false)
        filterListByName('left-list', "");
        document.getElementById("right-filter").value = "";
        filterListRemove('right-list');
        props.setSelectedElements([]);
        props.setResult(null);
        props.setTotal(null);
        setEnableBtnReportGenerate(false);
        renderList()
    }

    function addUnique(arr, obj) {
        console.log(arr);
        console.log(obj);
        if (obj) {
            if (!arr.some(item => item?.value?.codigo_orgao === obj?.value?.codigo_orgao)) {
                arr.push(obj);
                }
        }        
    }

    let rightListItems = []
    function moveItem(element, targetListId) {    
        if (!Array.from(document.getElementById(targetListId).querySelectorAll('li')).map(li => li.textContent).includes(element.textContent)) {
            document.getElementById(targetListId).appendChild(element);
        } else {
            document.getElementById(targetListId).appendChild(element);
            document.getElementById(targetListId).removeChild(element);
        }
        const value = element.dataset.value;
        const item = props.organOptions.find(i => JSON.stringify(i.value) === value);
        if (targetListId === 'right-list') {
            addUnique(rightListItems, item)
        } else {
            rightListItems = rightListItems.filter(i => JSON.stringify(i.value) !== value);
            document.getElementById("left-filter").value = "";
            setAgencyName(undefined)
            setSelectedOptionStatusOrgao(statusOrgaoOptions[0]);
            setPresencialAttendance(false);
            //filterListByName('left-list', "");
            //renderList();
        }
        props.setSelectedElements(rightListItems);
        props.setResult(null);
        props.setTotal(null);
        setEnableBtnReportGenerate(rightListItems.length > 0);
        
        element.onclick = function() {
            moveItem(this, element.parentElement.id === 'left-list' ? 'right-list' : 'left-list');
        };
    }
    function filterListByName(listId, query) {
        const list = document.getElementById(listId);
        const items = list.getElementsByTagName("li");
        Array.from(items).forEach(item => {
            if (query?.trim().length > 0) {
                item.style.display = item.textContent.toLowerCase().includes(query.toLowerCase()) ? "block" : "none";
            } else {
                item.style.display = "block";
            }
            
        });
    }
    function filterListRemove(listId) {
        const list = document.getElementById(listId);
        const items = list.getElementsByTagName("li");
        Array.from(items).forEach(item => {
            list.removeChild(item);            
        });
    }
    function filterList(listId) {
        const list = document.getElementById(listId);
        let items = list.getElementsByTagName("li");
        Array.from(items).forEach(item => {
            item.style.display = "none";

            const matchAgencyName = agencyName ? item.textContent.toLowerCase().includes(agencyName.toLowerCase()): true; 

            if ((selectedOptionStatusOrgao?.value === 'TODOS') && matchAgencyName){
                item.style.display = "block";
            } 
            if (((JSON.parse(item.getAttribute('data-value')).status_orgao) === (selectedOptionStatusOrgao?.value)) && matchAgencyName) {
                item.style.display = "block";
            }                             
        });

        if (presencialAttendance) {
            const itemsUnfiltered = list.getElementsByTagName("li");
            items = Array.from(itemsUnfiltered).filter(li => {
                const style = getComputedStyle(li);
                return style.display !== 'none';
              });
              Array.from(items).forEach(item => {
                item.style.display = "none";
                if ((JSON.parse(item.getAttribute('data-value')).atendimento_presencial) === (presencialAttendance?"S":"N")) {
                    item.style.display = "block";
                }
              });
            
        }
    }
    
    function renderList() {
        const leftList = document.getElementById("left-list");
        leftList.innerHTML = "";
        props.organOptions.forEach(item => {
            const li = document.createElement("li");
            li.textContent = item.label;
            li.dataset.value = JSON.stringify(item.value);
            li.onclick = function() {
                moveItem(this, 'right-list');
            };
            leftList.appendChild(li);
        });
    }

    function moveAllItens(fromId) {  
        const from = document.getElementById(fromId);

        const items = Array.from(from.querySelectorAll('li')); // Pegamos uma cópia da lista de itens (para não quebrar ao mover durante o loop)

        items.forEach(li => {
            if (li.style.display !== 'none') {
             //   to.appendChild(li);
                li.click();
            }
        });

        /*
        setEnableBtnReportGenerate(false);
        rightListItems = [];
        const from = document.getElementById(fromId);
        const to = document.getElementById(toId);

        // Pegamos uma cópia da lista de itens (para não quebrar ao mover durante o loop)
        const items = Array.from(from.querySelectorAll('li'));

        items.forEach(li => {
            if (li.style.display === 'block') {
                to.appendChild(li);
                if (fromId === 'left-list') {
                    const value = li.dataset.value;
                    console.log('value :' + value);
                    console.log('props.organOptions: ' + JSON.stringify(props.organOptions[0].value, null, 0));
                    const item = props.organOptions.find(i => JSON.stringify(i.value) === value);
                    console.log('item: ' + JSON.stringify(item, null, 0));
                    rightListItems.push(item);
                }
            }
        });

        props.setSelectedElements(rightListItems);
        props.setResult(null);
        props.setTotal(null);
        setEnableBtnReportGenerate(rightListItems.length > 0);
        document.getElementById("right-filter").value = "";
        */
    }
       
    useEffect(() => {
        renderList();
        setSelectedOptionStatusOrgao(statusOrgaoOptions[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.organOptions]);

    useEffect(() => {
        filterList('left-list');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agencyName, selectedOptionStatusOrgao, presencialAttendance]);
    

    // ESTILIZACAO PARA O SELECT ======================================================
    const SelecStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 6,
            height: 20
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            fontStyle: 'italic',
        }),
    }
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen 
                    ? <img src={DropUpIcon} alt="upicon" />
                    : <img src={DropDownIcon} alt="downicon"/>
                }
            </components.DropdownIndicator>
        );
    };
    
    const IndicatorSeparator = ({ innerProps }) => {
        return <span style={{}} {...innerProps} />;
    };
    // ================================================================================ 

    return (
        <>
            <ReportParameterContainer>
                <ModalCancel
                    id="modalcancelalert"
                    appear={modalCancel}
                    text={"Deseja retornar para a página anterior?"}
                    actionButton1={() => setModalCancel(false)}
                    actionButton2={() => props.history.push("/pesquisarcidadao")}
                />
                <ModalWarn
                    id="modalconfirmalert"
                    appear={props.modalError}
                    text={props.messageError}
                    textButton2='Ok'
                    actionButton2={() => props.setModalError(false)}
                />
                <Subtitle>
                    <img
                        src={FilterIcon}
                        alt="filterIcon"
                    />
                    <label> Selecione a(as) rede(es) de atendimento </label>
                    <Line />
                </Subtitle>
                <form onSubmit={handleSubmit(() => props.onSubmitSearch())}>
                    <DoubleListContainer>
                        <DoubleListSubContainer>
                            <ListContainerLeft>
                                <label>Disponíveis</label>
                                <input type="text" id="left-filter" placeholder="Filtrar..."  onInput={e =>setAgencyName(e.target.value)} />
                                <Select 
                                    onChange={(value) => {setSelectedOptionStatusOrgao(value); }}
                                    options={statusOrgaoOptions}
                                    value={selectedOptionStatusOrgao}
                                    placeholder="Selecione o status"
                                    styles={SelecStyles}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 6,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#CCCCCC',
                                            primary: '#1351B4'
                                        },
                                    })}
                                    components={
                                        { DropdownIndicator, IndicatorSeparator }
                                    }
                                />
                                <input
                                    id="presencial-attendance-checkbox"
                                    name="presencial-attendance"
                                    type="checkbox"
                                    checked={presencialAttendance}
                                    onChange={() => { setPresencialAttendance(!presencialAttendance); }}
                                />
                                <label htmlFor="presencial-attendance-checkbox" style={{fontWeight: "normal"}}>Participa do programa de atendimento presencial Balcão GOV.BR</label>
                                <ListContainer>                              
                                    <Ul id="left-list"></Ul>
                                </ListContainer>
                            </ListContainerLeft>
                            <ContainerMiddle>
                                <button className="br-button terciary" type="button" disabled={false}
                                    onClick={() => moveAllItens('left-list','right-list')}>
                                    {'>>'}
                                </button>
                                <button className="br-button terciary" type="button" disabled={false}
                                    onClick={() => moveAllItens('right-list', 'left-list')}>
                                    {'<<'}
                                </button>
                            </ContainerMiddle>                            
                            <ListContainerRight>
                                <label>Selecionados</label>
                                <input type="text" id="right-filter" placeholder="Filtrar..." onInput={e =>filterListByName('right-list', e.target.value)}/>
                                <ListContainer>                            
                                    <Ul id="right-list"></Ul>
                                </ListContainer>
                            </ListContainerRight>
                        </DoubleListSubContainer>
                    </DoubleListContainer>

                        <SearchButtonsContainer>
                            <button className="br-button terciary" type="button"
                                onClick={() => setModalCancel(true)}>
                                Voltar
                            </button>
                            <button className="br-button secondary" type="button"
                                onClick={() => resetFilters()}>
                                Limpar filtros
                            </button>
                            <button className="br-button terciary" type="button" disabled={!props.result}
                                onClick={() => props.csvGenerator()}>
                                Baixar arquivo csv
                            </button>
                            <button className="br-button terciary" type="button" disabled={!props.result}
                                onClick={() => window.print()}>
                                Imprimir
                            </button>
                            <button className={props.loadingReport ? "br-button primary loading" : "br-button primary"} type="submit" disabled={ !enableBtnReportGenerate }>
                                Gerar relatório
                            </button>
                        </SearchButtonsContainer>

                    <Subtitle>
                        <Line />
                    </Subtitle>
                </form>
            </ReportParameterContainer>
        </>
    );
}